<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>南航道主塔</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-tower" content="ST1#除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/tower/southChannelMainTower"></router-link>
          </el-tooltip>
          <div class="stati sta-tower">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorST1Dehumidifier,
                    humidityAllowedMaxST1Dehumidifier,
                    runningDehumidifierST1,
                    malfunctionDehumidifierST1
                  )
                }}
              </div>
              <div :class="errorST1Dehumidifier" class="state-info right-pos">
                <p>南航道主塔除湿机</p>
                <p>
                  <span>{{ humidityST1Dehumidifier | toFixed }}% {{ temperatureST1Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipST1" effect="light" placement="right"> -->
                  <span :class="runningClassST1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-t4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorT4, humidityAllowedMaxT4) }}
              </div>
              <div :class="errorT4" class="state-info right-pos">
                <p>塔内温湿度4</p>
                <p>
                  <span>{{ humidityT4 | toFixed }}% {{ temperatureT4 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-t3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorT3, humidityAllowedMaxT3) }}
              </div>
              <div :class="errorT3" class="state-info left-pos">
                <p>塔内温湿度3</p>
                <p>
                  <span>{{ humidityT3 | toFixed }}% {{ temperatureT3 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-t2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorT2, humidityAllowedMaxT2) }}
              </div>
              <div :class="errorT2" class="state-info right-pos">
                <p>塔内温湿度2</p>
                <p>
                  <span>{{ humidityT2 | toFixed }}% {{ temperatureT2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-t1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorT1, humidityAllowedMaxT1) }}
              </div>
              <div :class="errorT1" class="state-info left-pos">
                <p>塔内温湿度1</p>
                <p>
                  <span>{{ humidityT1 | toFixed }}% {{ temperatureT1 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>南航道桥钢箱梁</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-left" content="SN1#/SN2#除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/steelBox/sn1sn2"></router-link>
          </el-tooltip>
          <div class="stati sta-left-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorSN1Dehumidifier,
                    humidityAllowedMaxSN1Dehumidifier,
                    runningDehumidifierSN1,
                    malfunctionDehumidifierSN1
                  )
                }}
              </div>
              <div :class="errorSN1Dehumidifier" class="state-info right-pos">
                <p>SN1#除湿机</p>
                <p>
                  <span>{{ humiditySN1Dehumidifier | toFixed }}% {{ temperatureSN1Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipSN1" effect="light" placement="right"> -->
                  <span :class="runningClassSN1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-left-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorSN2Dehumidifier,
                    humidityAllowedMaxSN2Dehumidifier,
                    runningDehumidifierSN2,
                    malfunctionDehumidifierSN2
                  )
                }}
              </div>
              <div :class="errorSN2Dehumidifier" class="state-info left-pos">
                <p>SN2#除湿机</p>
                <p>
                  <span>{{ humiditySN2Dehumidifier | toFixed }}% {{ temperatureSN2Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipSN2" effect="light" placement="right"> -->
                  <span :class="runningClassSN2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-right" content="SS1#/SS2#除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/steelBox/ss1ss2"></router-link>
          </el-tooltip>
          <div class="stati sta-right-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorSS1Dehumidifier,
                    humidityAllowedMaxSS1Dehumidifier,
                    runningDehumidifierSS1,
                    malfunctionDehumidifierSS1
                  )
                }}
              </div>
              <div :class="errorSS1Dehumidifier" class="state-info right-pos">
                <p>SS1#除湿机</p>
                <p>
                  <span>{{ humiditySS1Dehumidifier | toFixed }}% {{ temperatureSS1Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipSS1" effect="light" placement="right"> -->
                  <span :class="runningClassSS1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-right-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorSS2Dehumidifier,
                    humidityAllowedMaxSS2Dehumidifier,
                    runningDehumidifierSS2,
                    malfunctionDehumidifierSS2
                  )
                }}
              </div>
              <div :class="errorSS2Dehumidifier" class="state-info left-pos">
                <p>SS2#除湿机</p>
                <p>
                  <span>{{ humiditySS2Dehumidifier | toFixed }}% {{ temperatureSS2Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipSS2" effect="light" placement="right"> -->
                  <span :class="runningClassSS2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb16">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNB16, humidityAllowedMaxNB16) }}
              </div>
              <div :class="errorNB16" class="state-info right-pos">
                <p>NB16梁段传感器</p>
                <p>
                  <span>{{ humidityNB16 | toFixed }}% {{ temperatureNB16 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNB13, humidityAllowedMaxNB13) }}
              </div>
              <div :class="errorNB13" class="state-info right-pos">
                <p>NB13梁段传感器</p>
                <p>
                  <span>{{ humidityNB13 | toFixed }}% {{ temperatureNB13 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nbh1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNBH1, humidityAllowedMaxNBH1) }}
              </div>
              <div :class="errorNBH1" class="state-info right-pos">
                <p>NBH1梁段传感器</p>
                <p>
                  <span>{{ humidityNBH1 | toFixed }}% {{ temperatureNBH1 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNB5, humidityAllowedMaxNB5) }}
              </div>
              <div :class="errorNB5" class="state-info right-pos">
                <p>NB5梁段传感器</p>
                <p>
                  <span>{{ humidityNB5 | toFixed }}% {{ temperatureNB5 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNB1, humidityAllowedMaxNB1) }}
              </div>
              <div :class="errorNB1" class="state-info right-pos">
                <p>NB1梁段传感器</p>
                <p>
                  <span>{{ humidityNB1 | toFixed }}% {{ temperatureNB1 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-04">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipError04, humidityAllowedMax04) }}
              </div>
              <div :class="error04" class="state-info left-pos">
                <p>04梁段传感器</p>
                <p>
                  <span>{{ humidity04 | toFixed }}% {{ temperature04 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz17">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNZ17, humidityAllowedMaxNZ17) }}
              </div>
              <div :class="errorNZ17" class="state-info left-pos">
                <p>NZ17梁段传感器</p>
                <p>
                  <span>{{ humidityNZ17 | toFixed }}% {{ temperatureNZ17 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNZ13, humidityAllowedMaxNZ13) }}
              </div>
              <div :class="errorNZ13" class="state-info left-pos">
                <p>NZ13梁段传感器</p>
                <p>
                  <span>{{ humidityNZ13 | toFixed }}% {{ temperatureNZ13 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNZ9, humidityAllowedMaxNZ9) }}
              </div>
              <div :class="errorNZ9" class="state-info left-pos">
                <p>NZ9梁段传感器</p>
                <p>
                  <span>{{ humidityNZ9 | toFixed }}% {{ temperatureNZ9 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNZ5, humidityAllowedMaxNZ5) }}
              </div>
              <div :class="errorNZ5" class="state-info left-pos">
                <p>NZ5梁段传感器</p>
                <p>
                  <span>{{ humidityNZ5 | toFixed }}% {{ temperatureNZ5 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNZ2, humidityAllowedMaxNZ2) }}
              </div>
              <div :class="errorNZ2" class="state-info left-pos">
                <p>NZ2梁段传感器</p>
                <p>
                  <span>{{ humidityNZ2 | toFixed }}% {{ temperatureNZ2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      //humidity, temperature
      humiditySN1Dehumidifier: "--",
      humiditySN2Dehumidifier: "--",
      humiditySS1Dehumidifier: "--",
      humiditySS2Dehumidifier: "--",
      humidityST1Dehumidifier: "--",
      temperatureSN1Dehumidifier: "--",
      temperatureSN2Dehumidifier: "--",
      temperatureSS1Dehumidifier: "--",
      temperatureSS2Dehumidifier: "--",
      temperatureST1Dehumidifier: "--",

      humidityNB16: "--",
      humidityNB13: "--",
      humidityNBH1: "--",
      humidityNB5: "--",
      humidityNB1: "--",
      humidity04: "--",
      humidityNZ17: "--",
      humidityNZ13: "--",
      humidityNZ9: "--",
      humidityNZ5: "--",
      humidityNZ2: "--",
      humidityT1: "--",
      humidityT2: "--",
      humidityT3: "--",
      humidityT4: "--",
      temperatureNB16: "--",
      temperatureNB13: "--",
      temperatureNBH1: "--",
      temperatureNB5: "--",
      temperatureNB1: "--",
      temperature04: "--",
      temperatureNZ17: "--",
      temperatureNZ13: "--",
      temperatureNZ9: "--",
      temperatureNZ5: "--",
      temperatureNZ2: "--",
      temperatureT1: "--",
      temperatureT2: "--",
      temperatureT3: "--",
      temperatureT4: "--",

      //humidity allowed max
      humidityAllowedMaxSN1Dehumidifier: "--",
      humidityAllowedMaxSN2Dehumidifier: "--",
      humidityAllowedMaxSS1Dehumidifier: "--",
      humidityAllowedMaxSS2Dehumidifier: "--",
      humidityAllowedMaxST1Dehumidifier: "--",
      humidityAllowedMaxNB16: "--",
      humidityAllowedMaxNB13: "--",
      humidityAllowedMaxNBH1: "--",
      humidityAllowedMaxNB5: "--",
      humidityAllowedMaxNB1: "--",
      humidityAllowedMax04: "--",
      humidityAllowedMaxNZ17: "--",
      humidityAllowedMaxNZ13: "--",
      humidityAllowedMaxNZ9: "--",
      humidityAllowedMaxNZ5: "--",
      humidityAllowedMaxNZ2: "--",
      humidityAllowedMaxT1: "--",
      humidityAllowedMaxT2: "--",
      humidityAllowedMaxT3: "--",
      humidityAllowedMaxT4: "--",

      //running
      runningDehumidifierSN1: "--",
      runningDehumidifierSN2: "--",
      runningDehumidifierSS1: "--",
      runningDehumidifierSS2: "--",
      runningDehumidifierST1: "--",

      //malfunction
      malfunctionDehumidifierSN1: "--",
      malfunctionDehumidifierSN2: "--",
      malfunctionDehumidifierSS1: "--",
      malfunctionDehumidifierSS2: "--",
      malfunctionDehumidifierST1: "--",

      //error
      errorSN1Dehumidifier: "--",
      errorSN2Dehumidifier: "--",
      errorSS1Dehumidifier: "--",
      errorSS2Dehumidifier: "--",
      errorST1Dehumidifier: "--",

      errorNB16: "--",
      errorNB13: "--",
      errorNBH1: "--",
      errorNB5: "--",
      errorNB1: "--",
      error04: "--",
      errorNZ17: "--",
      errorNZ13: "--",
      errorNZ9: "--",
      errorNZ5: "--",
      errorNZ2: "--",
      errorT1: "--",
      errorT2: "--",
      errorT3: "--",
      errorT4: "--",

      //humidity tooltip error
      humidityTooltipErrorSN1Dehumidifier: "--",
      humidityTooltipErrorSN2Dehumidifier: "--",
      humidityTooltipErrorSS1Dehumidifier: "--",
      humidityTooltipErrorSS2Dehumidifier: "--",
      humidityTooltipErrorST1Dehumidifier: "--",
      humidityTooltipErrorNB16: "--",
      humidityTooltipErrorNB13: "--",
      humidityTooltipErrorNBH1: "--",
      humidityTooltipErrorNB5: "--",
      humidityTooltipErrorNB1: "--",
      humidityTooltipError04: "--",
      humidityTooltipErrorNZ17: "--",
      humidityTooltipErrorNZ13: "--",
      humidityTooltipErrorNZ9: "--",
      humidityTooltipErrorNZ5: "--",
      humidityTooltipErrorNZ2: "--",
      humidityTooltipErrorT1: "--",
      humidityTooltipErrorT2: "--",
      humidityTooltipErrorT3: "--",
      humidityTooltipErrorT4: "--",

      // //running tooltip and class
      // runningTooltipSN1: "--",
      // runningTooltipSN2: "--",
      // runningTooltipSS1: "--",
      // runningTooltipSS2: "--",
      // runningTooltipST1: "--",

      runningClassSN1: "",
      runningClassSN2: "",
      runningClassSS1: "",
      runningClassSS2: "",
      runningClassST1: "",

      //humidity, temperature, running -> id
      dataNameIdDict: {
        //humidity, temperature
        humiditySN1Dehumidifier: "85259b42-4bcb-4e9d-a035-d1e74d1d0d36",
        humiditySN2Dehumidifier: "6ad4c9c2-a6f9-4e8d-b04c-ef5e6c9618f7",
        humiditySS1Dehumidifier: "06ef0977-85c9-4c7e-b597-d6849f29ae48",
        humiditySS2Dehumidifier: "e5ab352f-0806-4bdf-87db-ebd0d423e639",
        humidityST1Dehumidifier: "703d706c-a220-4c0b-b069-47be2f20c85c",
        temperatureSN1Dehumidifier: "87703303-47e9-4736-bed3-e566d42508fc",
        temperatureSN2Dehumidifier: "e497d3a7-a5cf-407d-8e52-df3eab747773",
        temperatureSS1Dehumidifier: "f48fa1d3-2bd1-4bd0-9f63-b8c8e57271a2",
        temperatureSS2Dehumidifier: "a463f6ca-8b6c-4b41-bc6a-fe6747d90177",
        temperatureST1Dehumidifier: "c89aebe2-255c-4135-8c2d-fc814f02b55e",

        humidityNB16: "e71dd67d-a4bc-4c6d-b650-aada25005ab7",
        humidityNB13: "098c9632-019b-4c34-a78d-d5bc2f54888c",
        humidityNBH1: "4dc70edd-d319-4045-a86e-690e0f017760",
        humidityNB5: "e49a0c98-3ea8-48ef-b061-7ebb3c3a6299",
        humidityNB1: "7f3729ba-3e99-4bdc-a72c-2565dd8f681d",
        humidity04: "68e2e609-b4da-4199-9a15-07c1888af756",
        humidityNZ17: "1d7d1772-796e-412e-8385-d42df2f9aa20",
        humidityNZ13: "f78ecbde-e02d-44ca-97df-a496fcc2c0f3",
        humidityNZ9: "8088b9c6-1184-44c4-aafa-57fc219ad655",
        humidityNZ5: "8da80cfe-e6dd-4e54-8e2e-bf2be08f69a3",
        humidityNZ2: "0e7c08ae-5db5-4b4c-ac96-549621d26b21",
        humidityT1: "a7f506ff-aa9a-414b-9128-5feb1cf56e3b",
        humidityT2: "e77ff459-f63e-4a56-8f3c-1d2c991baf4b",
        humidityT3: "f11082a0-c930-41ee-a7b9-8d592b1def0b",
        humidityT4: "55e2dea8-5c69-4be7-a7dd-e5a7df461148",
        temperatureNB16: "d62adad7-37f7-4689-9609-d4514e7aa3a8",
        temperatureNB13: "be14c04c-aa05-40bd-b304-94745511f22f",
        temperatureNBH1: "e0fe9ae4-29d7-44e4-a16a-f43202acdf9c",
        temperatureNB5: "7155d28c-3855-47b1-924e-eadc29bae9ed",
        temperatureNB1: "0e1d16ff-5fa5-40bc-b679-3b2cf685e6b4",
        temperature04: "6d8ff1e2-4c70-4eaa-a4d1-a74c074f1829",
        temperatureNZ17: "42c0e610-d7c2-49ac-8ca8-5c703c330c01",
        temperatureNZ13: "39466611-b46f-4402-8cbc-7bd512a7fd7a",
        temperatureNZ9: "04462430-3442-4e29-9ca1-446d9cf03a4e",
        temperatureNZ5: "cf7f01fb-ad76-402b-8f5e-725756a09dcf",
        temperatureNZ2: "09404d56-d6d7-4f91-9a58-711b35ccf7c1",
        temperatureT1: "8826d872-647e-4dd9-ba16-f4f9b31c6f3c",
        temperatureT2: "83adae74-5888-4175-880d-69ab4442f313",
        temperatureT3: "163d89e1-1576-47b5-8e5e-48a742d09818",
        temperatureT4: "2c950a77-930c-4cbc-b87d-1c0353df7201",

        //running
        runningDehumidifierSN1: "c4b8f459-918e-42a4-9f18-bfcedfd1c505",
        runningDehumidifierSN2: "53272fc6-5cd9-4ab1-addd-64f9cb02bd76",
        runningDehumidifierSS1: "ae5eb93a-322d-48fa-9cfb-8bce8bb38ec8",
        runningDehumidifierSS2: "38795735-bd5e-4522-9d18-46b762403fbf",
        runningDehumidifierST1: "52bd6403-0aef-49e4-ac27-8a94861a9ce7",

        //malfunction
        malfunctionDehumidifierSN1: "48add3b9-4f32-4b32-bd33-4b41793ee0c1",
        malfunctionDehumidifierSN2: "4a87f732-1d9c-4c9c-8ac6-b5ef01535828",
        malfunctionDehumidifierSS1: "9cb2379f-a985-4750-8e9b-5f18f095fb37",
        malfunctionDehumidifierSS2: "f403d209-76f6-412a-8dd5-9b699f45cc32",
        malfunctionDehumidifierST1: "22b950ff-52ad-4140-8896-a721398a6130",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxSN1Dehumidifier: "85259b42-4bcb-4e9d-a035-d1e74d1d0d36",
        humidityAllowedMaxSN2Dehumidifier: "6ad4c9c2-a6f9-4e8d-b04c-ef5e6c9618f7",
        humidityAllowedMaxSS1Dehumidifier: "06ef0977-85c9-4c7e-b597-d6849f29ae48",
        humidityAllowedMaxSS2Dehumidifier: "e5ab352f-0806-4bdf-87db-ebd0d423e639",
        humidityAllowedMaxST1Dehumidifier: "703d706c-a220-4c0b-b069-47be2f20c85c",
        humidityAllowedMaxNB16: "e71dd67d-a4bc-4c6d-b650-aada25005ab7",
        humidityAllowedMaxNB13: "098c9632-019b-4c34-a78d-d5bc2f54888c",
        humidityAllowedMaxNBH1: "4dc70edd-d319-4045-a86e-690e0f017760",
        humidityAllowedMaxNB5: "e49a0c98-3ea8-48ef-b061-7ebb3c3a6299",
        humidityAllowedMaxNB1: "7f3729ba-3e99-4bdc-a72c-2565dd8f681d",
        humidityAllowedMax04: "68e2e609-b4da-4199-9a15-07c1888af756",
        humidityAllowedMaxNZ17: "1d7d1772-796e-412e-8385-d42df2f9aa20",
        humidityAllowedMaxNZ13: "f78ecbde-e02d-44ca-97df-a496fcc2c0f3",
        humidityAllowedMaxNZ9: "8088b9c6-1184-44c4-aafa-57fc219ad655",
        humidityAllowedMaxNZ5: "8da80cfe-e6dd-4e54-8e2e-bf2be08f69a3",
        humidityAllowedMaxNZ2: "0e7c08ae-5db5-4b4c-ac96-549621d26b21",
        humidityAllowedMaxT1: "a7f506ff-aa9a-414b-9128-5feb1cf56e3b",
        humidityAllowedMaxT2: "e77ff459-f63e-4a56-8f3c-1d2c991baf4b",
        humidityAllowedMaxT3: "f11082a0-c930-41ee-a7b9-8d592b1def0b",
        humidityAllowedMaxT4: "55e2dea8-5c69-4be7-a7dd-e5a7df461148",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        //humidity, temperature
        humiditySN1Dehumidifier: "errorSN1Dehumidifier",
        humiditySN2Dehumidifier: "errorSN2Dehumidifier",
        humiditySS1Dehumidifier: "errorSS1Dehumidifier",
        humiditySS2Dehumidifier: "errorSS2Dehumidifier",
        humidityST1Dehumidifier: "errorST1Dehumidifier",
        temperatureSN1Dehumidifier: "errorSN1Sehumidifier",
        temperatureSN2Dehumidifier: "errorSN2Dehumidifier",
        temperatureSS1Dehumidifier: "errorSS1Dehumidifier",
        temperatureSS2Dehumidifier: "errorSS2Dehumidifier",
        temperatureST1Dehumidifier: "errorST1Dehumidifier",

        humidityNB16: "errorNB16",
        humidityNB13: "errorNB13",
        humidityNBH1: "errorNBH1",
        humidityNB5: "errorNB5",
        humidityNB1: "errorNB1",
        humidity04: "error04",
        humidityNZ17: "errorNZ17",
        humidityNZ13: "errorNZ13",
        humidityNZ9: "errorNZ9",
        humidityNZ5: "errorNZ5",
        humidityNZ2: "errorNZ2",
        humidityT1: "errorT1",
        humidityT2: "errorT2",
        humidityT3: "errorT3",
        humidityT4: "errorT4",
        temperatureNB16: "errorNB16",
        temperatureNB13: "errorNB13",
        temperatureNBH1: "errorNBH1",
        temperatureNB5: "errorNB5",
        temperatureNB1: "errorNB1",
        temperature04: "error04",
        temperatureNZ17: "errorNZ17",
        temperatureNZ13: "errorNZ13",
        temperatureNZ9: "errorNZ9",
        temperatureNZ5: "errorNZ5",
        temperatureNZ2: "errorNZ2",
        temperatureT1: "errorT1",
        temperatureT2: "errorT2",
        temperatureT3: "errorT3",
        temperatureT4: "errorT4",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict:{
        malfunctionDehumidifierSN1: "errorSN1Dehumidifier",
        malfunctionDehumidifierSN2: "errorSN2Dehumidifier",
        malfunctionDehumidifierSS1: "errorSS1Dehumidifier",
        malfunctionDehumidifierSS2: "errorSS2Dehumidifier",
        malfunctionDehumidifierST1: "errorST1Dehumidifier",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humiditySN1Dehumidifier: "humidityTooltipErrorSN1Dehumidifier",
        humiditySN2Dehumidifier: "humidityTooltipErrorSN2Dehumidifier",
        humiditySS1Dehumidifier: "humidityTooltipErrorSS1Dehumidifier",
        humiditySS2Dehumidifier: "humidityTooltipErrorSS2Dehumidifier",
        humidityST1Dehumidifier: "humidityTooltipErrorST1Dehumidifier",
        humidityNB16: "humidityTooltipErrorNB16",
        humidityNB13: "humidityTooltipErrorNB13",
        humidityNBH1: "humidityTooltipErrorNBH1",
        humidityNB5: "humidityTooltipErrorNB5",
        humidityNB1: "humidityTooltipErrorNB1",
        humidity04: "humidityTooltipError04",
        humidityNZ17: "humidityTooltipErrorNZ17",
        humidityNZ13: "humidityTooltipErrorNZ13",
        humidityNZ9: "humidityTooltipErrorNZ9",
        humidityNZ5: "humidityTooltipErrorNZ5",
        humidityNZ2: "humidityTooltipErrorNZ2",
        humidityT1: "humidityTooltipErrorT1",
        humidityT2: "humidityTooltipErrorT2",
        humidityT3: "humidityTooltipErrorT3",
        humidityT4: "humidityTooltipErrorT4",
      },

      // //running -> running tool tip
      // dataNameRunningTooltipNameDict: {
      //   runningDehumidifierSN1: "runningTooltipSN1",
      //   runningDehumidifierSN2: "runningTooltipSN2",
      //   runningDehumidifierSS1: "runningTooltipSS1",
      //   runningDehumidifierSS2: "runningTooltipSS2",
      //   runningDehumidifierST1: "runningTooltipST1",
      // },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierSN1: "runningClassSN1",
        runningDehumidifierSN2: "runningClassSN2",
        runningDehumidifierSS1: "runningClassSS1",
        runningDehumidifierSS2: "runningClassSS2",
        runningDehumidifierST1: "runningClassST1",
      },
      stationIdList: ["f94c4d56-f302-4fbd-8d03-34ec5363bbb8", "63ca1e0f-d549-4e89-8041-e3686790193d"],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (runningFlag > 0) {
        result += ", 除湿机运行";
      } else if(runningFlag === 0) {
        result += ", 除湿机停止";
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 78px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/hangzhouwan/bridgeLine_south.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 258px;
          left: 335px;
        }

        .station-block-right {
          top: 258px;
          left: 859px;
        }

        .station-block-tower {
          top: 230px;
          left: 540px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }
        .sta-left-left {
          top: 265px;
          left: 303px;
          &::before {
            bottom: -25px;
            left: 5px;
            width: 50px;
            transform: rotate(-45deg);
          }
          &::after {
            bottom: -43px;
            left: -2px;
          }
          .state-info {
            right: 2px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-left-right {
          top: 265px;
          left: 303px;
          &::before {
            bottom: -25px;
            left: 33px;
            width: 50px;
            transform: rotate(225deg);
          }
          &::after {
            bottom: -43px;
            left: 75px;
          }
          .state-info {
            right: -220px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right-left {
          top: 265px;
          left: 827px;
          &::before {
            bottom: -25px;
            left: 5px;
            width: 50px;
            transform: rotate(-45deg);
          }
          &::after {
            bottom: -43px;
            left: -2px;
          }
          .state-info {
            right: 2px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right-right {
          top: 265px;
          left: 827px;
          &::before {
            bottom: -25px;
            left: 33px;
            width: 50px;
            transform: rotate(225deg);
          }
          &::after {
            bottom: -43px;
            left: 75px;
          }
          .state-info {
            right: -220px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-tower {
          top: 230px;
          left: 544px;
          &::before {
            bottom: 7px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 24px;
            left: -40px;
          }
          .state-info {
            right: 40px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }
        .sensor-nb16 {
          top: 263px;
          left: 85px;
          &::before {
            bottom: 30px;
            left: -52px;
            width: 70px;
            transform: rotate(40deg);
          }
          &::after {
            bottom: 52px;
            left: -59px;
          }
          .state-info {
            right: 70px;
            top: -37px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nb13 {
          top: 263px;
          left: 178px;
          &::before {
            bottom: 60px;
            left: -81px;
            width: 120px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 112px;
            left: -65px;
          }
          .state-info {
            right: 82px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nbh1 {
          top: 263px;
          left: 274px;
          &::before {
            bottom: 89px;
            left: -133px;
            width: 190px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 170px;
            left: -99px;
          }
          .state-info {
            right: 116px;
            top: -155px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nb5 {
          top: 263px;
          left: 390px;
          &::before {
            bottom: 105px;
            left: -133px;
            width: 210px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 204px;
            left: -78px;
          }
          .state-info {
            right: 95px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nb1 {
          top: 263px;
          left: 503px;
          &::before {
            bottom: 122px;
            left: -130px;
            width: 235px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 237px;
            left: -48px;
          }
          .state-info {
            right: 62px;
            top: -222px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-04 {
          top: 263px;
          left: 1100px;
          &::before {
            bottom: 30px;
            left: -2px;
            width: 70px;
            transform: rotate(140deg);
          }
          &::after {
            bottom: 52px;
            left: 58px;
          }
          .state-info {
            right: -169px;
            top: -37px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nz17 {
          top: 263px;
          left: 1015px;
          &::before {
            bottom: 60px;
            left: -23px;
            width: 120px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 112px;
            left: 66px;
          }
          .state-info {
            right: -179px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nz13 {
          top: 263px;
          left: 907px;
          &::before {
            bottom: 89px;
            left: -40px;
            width: 190px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 170px;
            left: 101px;
          }
          .state-info {
            right: -212px;
            top: -155px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nz9 {
          top: 263px;
          left: 801px;
          &::before {
            bottom: 105px;
            left: -59px;
            width: 210px;
            transform: rotate(112deg);
          }
          &::after {
            bottom: 203px;
            left: 84px;
          }
          .state-info {
            right: -192px;
            top: -188px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nz5 {
          top: 263px;
          left: 693px;
          &::before {
            bottom: 127px;
            left: -80px;
            width: 250px;
            transform: rotate(107deg);
          }
          &::after {
            bottom: 246px;
            left: 81px;
          }
          .state-info {
            right: -187px;
            top: -231px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nz2 {
          top: 263px;
          left: 612px;
          &::before {
            bottom: 134px;
            left: -109px;
            width: 255px;
            transform: rotate(95deg);
          }
          &::after {
            bottom: 260px;
            left: 29px;
          }
          .state-info {
            right: -137px;
            top: -246px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t4 {
          top: 30px;
          left: 544px;
          &::before {
            bottom: 22px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 39px;
            left: -40px;
          }
          .state-info {
            right: 56px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t3 {
          top: 80px;
          left: 544px;
          &::before {
            bottom: 22px;
            left: 0px;
            width: 50px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 39px;
            left: 42px;
          }
          .state-info {
            right: -152px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t2 {
          top: 130px;
          left: 544px;
          &::before {
            bottom: 22px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 39px;
            left: -40px;
          }
          .state-info {
            right: 56px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t1 {
          top: 180px;
          left: 544px;
          &::before {
            bottom: 22px;
            left: 0px;
            width: 50px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 39px;
            left: 42px;
          }
          .state-info {
            right: -152px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
      }
    }
  }
}
</style>